<template>
  <div class="home-search-container">
    <div class="search-input">
      <input class="search-text" />
      <input
        type="button"
        class="search-button"
        value="搜索"
      />
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.home-search-container {
  background: #f1f1f1;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  .search-input {
    display: flex;
    align-items: center;
    input {
      height: 36px;
    }
    .search-text {
      width: 20vw;
      min-width: 100px;
      border-color: #eeca00;
      border: 1px solid #eeca00;
      outline: #eeca00;
    }
    .search-button {
      width: 100px;
      height: 36px;
      color: #000;
      font-size: 15px;
      letter-spacing: 1px;
      background: #eeca00;
      border-bottom: 1px solid #eeca00;
      outline: medium;
      border: 0;
      -webkit-appearance: none;
      -webkit-border-radius: 0;
      cursor: pointer;
    }
  }
}
</style>
